import { render, staticRenderFns } from "./AutoPostBoostingAd.vue?vue&type=template&id=492708ba&scoped=true&"
import script from "./AutoPostBoostingAd.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoostingAd.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoostingAd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AutoPostBoostingAd.vue?vue&type=style&index=1&id=492708ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492708ba",
  null
  
)

export default component.exports